module.exports = "/images/print-icon.svg?5fb4b1cf6fff446198d35d639a02f941";